var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EbxStaggeringTransitionGroup',{staticClass:"ebx-grid",class:_vm.gridColumnsClass,attrs:{"stagger":_vm.stagger,"appear":"","name":"ebx-grid-item--animation","tag":"section"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }